import { Component, EventEmitter, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { Rate} from '../../../../model/Rate';
import { RatesService } from '../../../../service/rates.service';
import { ToastrService } from 'ngx-toastr';
import { DarkModeService } from '../../../../service/dark-mode.service';

@Component({
  selector: 'ch-update-rates',
  templateUrl: './update-rates.component.html'
})
export class UpdateRatesComponent implements OnInit {

  rate: Rate;
  updateRatesForm: UntypedFormGroup;
  rateUpdated: EventEmitter<void> = new EventEmitter<void>();

  constructor(private readonly fb: UntypedFormBuilder,
              public readonly darkModeService: DarkModeService,
              private readonly rateService: RatesService,
              private readonly toastr: ToastrService,
              public readonly modalRef: BsModalRef) {
  }

  ngOnInit(): void {
    this.updateRatesForm = this.fb.group({
      currencyPair: new UntypedFormControl({value: this.rate.currencyPair, disabled: true}),
      bid: new UntypedFormControl(this.rate.bid),
      offer: new UntypedFormControl(this.rate.offer)
    });
  }

  update() {
    this.rateService.updateRate(this.updateRatesForm.getRawValue()).subscribe(() => {
      this.rateUpdated.emit();
      this.toastr.show('Rate updated');
    }, err => {
      console.log(err);
      this.toastr.error(err.message);
    });
  }
}
